import React from "react";
import PropTypes from "prop-types";

import { ReactComponent as CellphoneIcon } from "../assets/icons/cellphone.svg";
import { ReactComponent as AlcoholIcon } from "../assets/icons/alcohol.svg";
import { ReactComponent as SpeedLimitIcon } from "../assets/icons/speed-limit.svg";
import { ReactComponent as TrafficLightIcon } from "../assets/icons/traffic-light.svg";
import { ReactComponent as DistanceIcon } from "../assets/icons/too-close.svg";

const iconComponents = {
  MOBILE_PHONE: CellphoneIcon,
  SPEEDING: SpeedLimitIcon,
  RED_LIGHT: TrafficLightIcon,
  DISTANCE: DistanceIcon,
  ALCOHOL: AlcoholIcon,
};

const SvgIcon = ({ type, ...props }) => {
  const IconComponent = iconComponents[type];

  if (IconComponent) {
    return <IconComponent {...props} />;
  }
};

SvgIcon.propTypes = {
  type: PropTypes.oneOf([
    "MOBILE_PHONE",
    "SPEEDING",
    "RED_LIGHT",
    "DISTANCE",
    "ALCOHOL",
  ]).isRequired,
};

export default SvgIcon;
